"use client";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "../../../navigation";
import { useSearchParams } from "next/navigation";
import SearchHandlerInput from "../../layout/components/SearchHandlerInput";

const NewsFilters = ({ queryString = "" }) => {
  const router = useRouter();
  const t = useTranslations();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const updateRoute = (key, value) => {
    const params = new URLSearchParams(searchParams.toString());
    if (!value) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };
  return (
    <div className="mb-5 row">
      <div className="col-md-6">
        <div className="mb-1">{t("search")}</div>
        <SearchHandlerInput
          searchTerm={queryString}
          onSearch={(val) => updateRoute("queryString", val)}
          setSearchTerm={(val) => updateRoute("queryString", val)}
        />
      </div>
    </div>
  );
};

export default NewsFilters;
